import api from './api';

export const blogService = {
  list: async (params = {}) => {
    const res = await api.get('/blogs', { params });
    return res.data;
  },

  getById: async (id) => {
    const res = await api.get(`/blogs/${id}`);
    return res.data;
  },

  create: async (data) => {
    const res = await api.post('/blogs', data);
    return res.data;
  },

  update: async (id, data) => {
    const res = await api.put(`/blogs/${id}`, data);
    return res.data;
  },

  remove: async (id) => {
    const res = await api.delete(`/blogs/${id}`);
    return res.data;
  }
};

export default blogService;


